import { cn } from 'cn'

export const CTA_BUTTON_CLASS =
  'flex items-center justify-center px-8 py-3 rounded-md shadow-sm bg-linear-to-r from-orange-700 to-orange-500 text-white font-medium hover:from-orange-600 hover:to-orange-400 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-orange-400 focus:ring-offset-gray-900 md:py-4 md:text-lg md:px-10'

export function ctaButtonClass({ fullWidth }: { fullWidth?: boolean }) {
  return cn(CTA_BUTTON_CLASS, {
    'w-full': fullWidth
  })
}
